import { useTranslation } from "react-i18next"
import { Navigate, useNavigate } from "react-router-dom"
import { IRole, useRoleStore } from "@/app/store/slices/role-store"
import ArrowRightIcon from "@/pages/icons/arrow-right"
import UserIcon from "@/pages/icons/user"
import { roles } from "../../constants"
import Cookies from "js-cookie"
import { useMutation } from "@tanstack/react-query"
import { submitRole } from "../../api"
import { useCallback } from "react"

const RoleSelectPage = () => {
  const { t } = useTranslation("auth")
  const navigate = useNavigate()
  const setRole = useRoleStore(state => state.setRole)

  const session_id = Cookies.get("session_id")

  const submitUserRole = useMutation({
    mutationFn: submitRole,
    onSuccess: () => {
      navigate("/auth/submit-request")
    }
  })

  const handleRoleClick = useCallback(
    (item: IRole) => {
      setRole(item)

      submitUserRole.mutate({
        session_id: session_id!,
        base_role: item.value
      })
    },
    [session_id, setRole, submitUserRole]
  )

  if (!session_id) {
    return <Navigate to={"/auth/login"} replace={true} />
  }

  return (
    <div className="dark:bg-zinc-500 bg-white p-8 flex flex-col gap-6 rounded-xl w-full max-w-[752px]">
      <div className="text-center flex flex-col gap-3">
        <h3 className="text-[#101A23] text-[28px] font-medium">{t("signInSystem")}</h3>
        <p className="text-[#738195] text-[20px]">Выберите электронный ключ для входа в систему</p>
      </div>

      <hr />

      {roles.map(item => (
        <div key={item.id} className="flex items-center justify-between p-5 border rounded-xl">
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center size-11 bg-[#94A3B8]/20 rounded-full">
              <UserIcon className="size-6" />
            </div>
            <div className="flex flex-col items-start">
              <p className="text-[#101A23] font-medium text-[20px]">{item.name}</p>
              <span className="text-[#64748A] text-[18px]">{item.description}</span>
            </div>
          </div>

          <button onClick={() => handleRoleClick(item)} disabled={submitUserRole.isPending}>
            <ArrowRightIcon />
          </button>
        </div>
      ))}
    </div>
  )
}

export default RoleSelectPage
